/**
 * Format Approach A fidelity + needs_review counts for the Completion Rules column.
 * @param {{ fidelity?: Record<string, number>, needsReview?: number } | null | undefined} report
 * @returns {string|null}
 */
export const formatMigrationFidelitySummary = (report) => {
  if (!report || typeof report !== 'object') return null;
  const fidelity = report.fidelity || {};
  const parts = [];
  const oneToOne = Number(fidelity['1to1'] || 0);
  const partial = Number(fidelity.partial || 0);
  const redesign = Number(fidelity.redesign || 0);
  const drop = Number(fidelity.drop || 0);
  const needsReview = Number(report.needsReview || 0);

  if (oneToOne > 0) parts.push(`${oneToOne}×1:1`);
  if (partial > 0) parts.push(`${partial} partial`);
  if (redesign > 0) parts.push(`${redesign} redesign`);
  if (drop > 0) parts.push(`${drop} drop`);
  if (needsReview > 0) parts.push(`${needsReview} needs review`);

  return parts.length > 0 ? parts.join(' · ') : null;
};

/**
 * Retry is available for failed/deferred/pending (stuck pending after early worker errors).
 * @param {string|null|undefined} status
 */
export const canRetryCompletionRuleMigration = (status) =>
  status === 'failed' || status === 'deferred' || status === 'pending';
